import React, { useState } from 'react';
// material
import { Grid } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
// components
import TextInput from '../inputs/TextInput';
import SelectInput, { SelectItem } from '../inputs/SelectInput';

interface AddCampaignMessageProps {
  templates: SelectItem[];
  selected: string;
  message: string;
  redirectUrl: string;
  contactName: string;
  onChange(name: string, value: string): void;
}

const AddCampaignMessage: React.FC<AddCampaignMessageProps> = (props) => {

  const classes = useStyles({});

  return (
    <div>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextInput
            title="Message Link Url (optional: will create a shortlink)"
            type="string"
            placeholder=""
            result={props.redirectUrl}
            onChange={(event: any) => props.onChange('redirectUrl', event.target.value)}
          />
        </Grid>
        <Grid item xs={12}>
          <TextInput
            title="Contact Name *"
            type="string"
            placeholder=""
            result={props.contactName}
            onChange={(event: any) => props.onChange('contactName', event.target.value)}
          />
        </Grid>
        <Grid item xs={12}>
          <SelectInput
            title="Templates *"
            value={props.selected}
            values={props.templates}
            onChange={(event: any) => props.onChange('template', event.target.value)}
          />
        </Grid>
        <Grid item xs={12}>
          <div className={classes.template}>{props.message}</div>
        </Grid>
      </Grid>
    </div>
  );

}
export default AddCampaignMessage;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      padding: 10
    },
    template: {
      marginTop: 40
    }
  })
);



// WEBPACK FOOTER //
// ./src/components/campaign/AddCampaignMessage.tsx